





































interface department { no: string | number, name: string }
interface departList { accountBookId: number; code: null; fullcode: null; hidden: string; id: number | string; leaf: null; name: string; no: string; pid: null; pno: null; }
interface employeeList { accountBookId: number; dimDepartmentId: null; assDepartmentName: null; code: null; fullcode: null; hidden: string; id: number | string; licenseNo: string; licenseType: string; name: string; no: string; phone: string; }
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AssistDepartment from "../../data/AssistDepartment";

import { mapGetters } from "vuex";
import AccountingSystem from "@/data/AccountingSystem";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class NewAddDepart extends Vue {
    // 部门下拉
    departments = AssistDepartment;
    department: department = {
        no: "",
        name: ""
    }

    @Prop({ type: Array, default: [] })
    departList!: departList[];

    mounted() {
        if (this.$store.state.accountBook.accountingSystem === AccountingSystem.npo) {
            this.departments = ["管理部门", "销售部门", "行政部门"]
        } else {
            this.departments = AssistDepartment
        }
        this.department.no = this.getNo();
    }

    getNo() {
        let no;
        if (this.departList.length > 0) no = parseInt(this.departList[this.departList.length - 1].no) + 1;
        else no = 1;
        if (no < 10) {
            return "000" + String(no);
        } else if (no < 100) {
            return "00" + String(no);
        } else if (no < 1000) {
            return "0" + String(no);
        } else {
            return no
        }
    }

    toNext(index: number) {
        let allInput: any = this.$el.querySelectorAll("input");
        if (index < 1) allInput[index + 1].focus();
        else this.confirm();
    }

    confirm() {
        if (
            this.department.no != "" &&
            this.department.name != ""
        ) {
            Vue.axios
                .post(`dim/department/add`, {
                    accountBookId: this.$store.state.accountBook.id,
                    bankAccount: "",
                    contact: "",
                    hidden: "n",
                    measureUnit: "",
                    name: this.department.name,
                    no: this.department.no,
                    phone: "",
                    taxNo: ""
                })
                .then(res => {
                    this.$emit("success", res.data);
                });
        } else {
            this.$message("亲，请将数据完整填写");
            (<any>this.$el.querySelector("input")).focus();
        }
    }
    close() {
        this.$emit("close");
    }

}
